import * as React from 'react';
import Typography from '@mui/material/Typography';
import Section from '../components/Section';
import Eyebrow from '../components/Eyebrow';

/** 下層ページ共通のページヘッダ（kinari 地・中央揃え）。 */
export default function PageHead({ eyebrow, title, lead }) {
  return (
    <Section bg="kinari" py={0} sx={{ textAlign: 'center', pt: { xs: 7, sm: 11 }, pb: { xs: 6, sm: 9 } }}>
      {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
      <Typography variant="h2" component="h1" sx={{ fontSize: { xs: 28, sm: 38 } }}>
        {title}
      </Typography>
      {lead ? (
        <Typography sx={{ fontSize: 15, color: 'text.secondary', letterSpacing: '.08em', mt: 2 }}>{lead}</Typography>
      ) : null}
    </Section>
  );
}
